import { Box, Stack, Typography, useTheme } from "@mui/material";
import awesome from "assets/lottie/awesome.json";
import dissapointed from "assets/lottie/dissapointed.json";
import happy from "assets/lottie/happy.json";
import needToImprove from "assets/lottie/needToImprove.json";
import satisfied from "assets/lottie/satisfied.json";
import Lottie from "lottie-react";
import { useEffect, useState } from "react";

export const FeedbackCard = ({
  feedback,
  rating,
}: {
  feedback?: string | null;
  rating?: number | null;
}) => {
  const [ratingText, setRatingText] = useState("");
  const theme = useTheme();

  useEffect(() => {
    if (rating) {
      getRatingText(rating);
    }
  }, [rating]);

  const getRatingText = (rating: number) => {
    let value = "Awesome";
    switch (rating) {
      case 1:
        value = "Disappointed";
        break;
      case 2:
        value = "Need To Improve";
        break;
      case 3:
        value = "Satisfied";
        break;
      case 4:
        value = "Good";
        break;
      case 5:
        value = "Awesome";
        break;

      default:
        value = "Awesome";
        break;
    }
    setRatingText(value);
  };

  if (!rating) {
    return <></>;
  }
  return (
    <Stack
      sx={{
        minWidth: "270px",
        maxWidth: "40%",
        backgroundColor: theme.palette.neutral["005"],
        mt: "20px",
        borderRadius: "0px 16px 16px 16px",

        padding: "20px",
      }}
    >
      <Stack
        sx={{
          alignItems: "center",
          gap: "4px",
          justifyContent: "center",
          backgroundColor: "#FFF",
          border: `1px solid ${theme.palette.neutral["020"]}`,
          borderRadius: "16px",
          padding: "20px",
        }}
      >
        <Box width="96px" height="96px">
          <LottieComponent
            width="96px"
            height="96px"
            //   animationData={getRatingText("file")}
            rating={rating}
          />
        </Box>
        <Typography variant="subtitle1">{ratingText}</Typography>
        <Typography
          variant="body-xsmall"
          sx={{ whiteSpace: "pre-line", textAlign: "center" }}
        >
          {feedback}
        </Typography>
      </Stack>
    </Stack>
  );
};

const LottieComponent = ({
  rating,
  width,
  height,
}: {
  rating: number;
  width?: string;
  height?: string;
}) => {
  switch (rating) {
    case 1:
      return (
        <Lottie
          animationData={dissapointed}
          width={width}
          height={height}
          loop={true}
        />
      );
    case 2:
      return (
        <Lottie
          animationData={needToImprove}
          width={width}
          height={height}
          loop={true}
        />
      );
    case 3:
      return (
        <Lottie
          animationData={satisfied}
          width={width}
          height={height}
          loop={true}
        />
      );
    case 4:
      return (
        <Lottie
          animationData={happy}
          width={width}
          height={height}
          loop={true}
        />
      );
    case 5:
      return (
        <Lottie
          animationData={awesome}
          width={width}
          height={height}
          loop={true}
        />
      );

    default:
      return (
        <Lottie
          animationData={awesome}
          width={width}
          height={height}
          loop={true}
        />
      );
  }
};
